<template>
	<div class="flex w-full items-center justify-between gap-x-3">
		<span class="text-base font-normal leading-[24px] text-white">
			Sobre a Pilar
		</span>
		<IconMaterialSymbolsLightChevronRight class="size-6 text-beige" />
	</div>
</template>

<script setup lang="ts"></script>
